export default {
  POST_REPORT_DETAIL_REQUEST: 'APP/POST_REPORT_DETAIL/POST_REPORT_DETAIL_REQUEST',
  POST_REPORT_DETAIL_SUCCESS: 'APP/POST_REPORT_DETAIL/POST_REPORT_DETAIL_SUCCESS',
  POST_REPORT_DETAIL_ERROR: 'APP/POST_REPORT_DETAIL/POST_REPORT_DETAIL_ERROR',
};
